var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "none",
      transformOrigin: "50% 50%",
      cursor: "move"
    },
    width: 512,
    height: 512,
    viewBox: "0 0 5120 5120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l6ftcZLL5yJTtQmgcjaHsIX",
    fill: "rgb(0,0,0)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pxOGZWMBv",
    d: "M3588 4860 c-146 -23 -313 -89 -421 -166 -72 -51 -2667 -2644 -2727 -2724 -68 -92 -127 -215 -157 -328 -22 -82 -26 -118 -26 -237 0 -119 4 -155 26 -237 27 -104 87 -232 145 -313 37 -52 301 -325 313 -325 4 0 184 188 400 418 216 229 421 447 457 484 l65 67 -42 46 c-24 26 -55 72 -69 103 -24 50 -27 70 -27 157 0 174 -58 104 804 968 871 873 810 822 986 822 87 0 107 -3 157 -27 31 -14 77 -45 102 -68 l46 -42 69 63 c38 35 259 242 490 459 l420 395 -127 128 c-146 147 -223 208 -340 267 -152 76 -386 115 -544 90z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pGy6sJXsC",
    d: "M4186 3837 l-489 -461 39 -34 c21 -19 53 -41 71 -48 44 -19 121 -17 160 4 17 9 196 172 397 362 257 242 372 357 386 385 36 75 17 168 -46 226 l-29 27 -489 -461z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "pB700V1sY",
    d: "M3627 2546 c-9 -9 -16 -48 -20 -113 -10 -163 -65 -324 -163 -475 -56 -87 -185 -218 -272 -277 -143 -96 -323 -159 -485 -168 -102 -6 -127 -17 -127 -52 0 -37 25 -44 128 -38 529 31 976 479 1009 1009 4 71 2 102 -7 113 -16 19 -44 19 -63 1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "pneiOYx9k",
    d: "M4218 2478 c-13 -10 -19 -44 -27 -141 -41 -488 -279 -896 -676 -1159 -222 -147 -452 -225 -732 -249 -97 -8 -131 -14 -140 -27 -19 -23 -16 -40 10 -56 19 -13 41 -14 142 -6 400 33 732 186 1016 469 283 284 436 616 469 1016 8 101 7 123 -6 142 -16 26 -33 29 -56 11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "pZiqWx4Kn",
    d: "M4793 2398 c-5 -7 -15 -80 -21 -163 -23 -294 -84 -519 -209 -770 -197 -394 -518 -715 -911 -910 -257 -128 -503 -192 -804 -210 -124 -8 -142 -16 -136 -56 6 -41 26 -44 186 -31 299 25 540 91 793 217 216 108 380 226 554 400 377 376 586 846 621 1397 5 80 4 112 -6 123 -15 18 -54 20 -67 3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "p1FVGsJUv9",
    d: "M1278 932 l-457 -487 27 -29 c35 -38 97 -66 146 -66 80 0 106 23 467 406 189 201 352 380 361 397 19 36 23 112 7 154 -11 30 -76 113 -87 112 -4 0 -213 -219 -464 -487z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0f6bec2c748497ded3c8a343b9aefe1e.svg";
export { ForwardRef as ReactComponent };